<ng-container *ngIf="showCampaign$ | async">
  <div
    data-testid="campaign-container"
    class="campaign fixed fill z1"
    *ngIf="campaignAndArticle$ | async as campaignAndArticle"
  >
    <div class="campaign-promo grid-max-width center grid-col-12 no-row-gap">
      <div
        class="campaign-promo-content white-bg border rounded-large col-1-12 md-col-1-4 overflow-hidden shadow-highlight mobile-bleed"
        *ngIf="promoVisibleDelayed$ | async"
        [class.is-vishidden]="(promoVisibleDelayed$ | async) === false"
        [class.campaign-promo-content--active]="promoVisible$ | finDelay | async"
        data-testid="campaign-promo"
      >
        <div class="flex">
          <div class="flex-1 flex--basis0 relative">
            <fcom-image
              *ngIf="campaignAndArticle.article.picture"
              class="picture block rounded-top-large border-top border-left border-right border"
              [ratio]="'4x3'"
              [fillParent]="true"
              [scale]="false"
              [imageData]="campaignAndArticle.article.picture"
            ></fcom-image>
          </div>
          <div class="flex-2 flex--basis0 ps-medium">
            <h3 class="font-body-1 ps-medium-b flex">
              <span class="heather-700-text flex-1">{{ campaignAndArticle.article.teaserTitle }}</span>
              <button
                (click)="closeCampaign()"
                [attr.title]="'actions.close' | finLocalization"
                [attr.aria-label]="'actions.close' | finLocalization"
                data-testid="close-campaign"
                class="focus-inset flex--nogrow"
              >
                <fcom-icon [name]="SvgLibraryIcon.CLOSE_DELETE"></fcom-icon>
              </button>
            </h3>
            <div class="ps-xsmall-b" [innerHTML]="campaignAndArticle.article.teaserText | finSafe: 'html'"></div>

            <button class="focus-inset font-body-1" (click)="ctaClicked(campaignAndArticle.campaign.categories)">
              {{ 'campaign.' + campaignAndArticle.campaign.id + '.cta' | finLocalization }}
              <fcom-icon aria-hidden="true" class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT"></fcom-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
